//state的获取
const getters = {
    //state中的token，当用户登录后，后台传递会一个token，api中将token赋值给了state，以后请求时将token返回即可
    token: state => state.user.token,
    id: state => state.user.id,
    //用户名
    name: state => state.user.name,
    //用户昵称
    nick: state => state.user.nick,
    //部门机构名称
    depart: state => state.user.depart,
    uhead: state => state.user.uhead,
    isUhead: state => state.user.isUhead,
    //权限
    menus: state => state.user.perms.menu,
    perms: state => state.user.perms.button,
    roles: state => state.user.roles,
    //以上为自带，功能有些并未使用

    /****************************总体信息************************************/
    //获取用户的id
    userId: state => state.user.id,
    //主题颜色
    themeColor: state => state.menu.color,
    //面包屑导航中的地图导航栏
    mapDisplay: state => state.menu.mapDisplay,
    //左侧侧边栏
    sideBar: state => state.menu.sideBar,
    //权限列表
    permList: state => state.menu.permList,
    //处理过后的权限列表
    ProcessingPermList: state => state.menu.ProcessingPermList,
    //获取系统当前页面的菜单权限
    menuChildren: state => state.menu.menuChildren,
    //当前激活状态下的组件
    CurrentActiveComponent: state => state.menu.currentActiveComponent,
    //缩放比例
    scale: state => state.menu.scale,
    // 侧边栏激活的索引
    sideBarIndex: state => state.menu.sideBarIndex,
    /***************************当前地图的信息***********************************/
    // 点击事件
    _axiosPromiseCancel: state => state.menu._axiosPromiseCancel //axios正在请求的接口
};
export default getters;
